import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import '@/assets/scss/main.scss'
import { env } from './conf/conf.js'
import * as VueGoogleMaps from 'vue2-google-maps'
//import date from './utils/date'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBb14nrVdCZh_uBI-wGkjjmB0ypHS4YInY',
    libraries: 'geometry',
    loading: 'async',
  },
})

if (localStorage.getItem('state')) {
  store.state.user = JSON.parse(localStorage.getItem('state'));

  // SCRIPT WEHELP
  if (env === 'prod') {
    window.onload = function () {

      let user = JSON.parse(localStorage.getItem('state')).usuario
      if (user.wehelp_token) {

        /*
        let state = user.localidade ? user.localidade.split('/')[1] : ''
        let country = user.localidade ? user.localidade.split('/')[2] : ''

        var wehelpCustomerInfo = {
          debug: 1,
          survey_token: user.wehelp_token,
          type: 'modal',
          message_open: 0,
          language: 'PORTUGUESE',
          company_unit: user.wehelp_unity,
          person: {
            internal_code: user.id,
            name: user.nome,
            email: user.email,
            phone: user.celular || '',
            type: 'CUSTOMER',
            language: 'PORTUGUESE',
            created_at: user.criado_em,
            state: state,
            country: country,
            gender: user.genero,
            company_unit: user.wehelp_unity
          }
        };

        window.loadWeHelpWidgetScreen('https://app.wehelpsoftware.com', wehelpCustomerInfo, 'root-wehelp'); */
      }
    }
  }
}

if (!store.state.user.usuario.id && location.pathname != '/' && location.pathname != '/login' && location.pathname != '/supporter/novo' && location.pathname.indexOf('/supporter/usuario/') < 0 && location.pathname.indexOf('/redefinir-senha/') < 0) {
  localStorage.setItem('externalLink', location.href)
  alert('Login necessário')
  window.location = '/'
}

if (store.state.user.usuario.white_label && location.pathname != '/atendimento' && location.pathname != '/avaliacao' && location.pathname != '/cliente/relatorios') {
  window.location = '/atendimento'
}

Vue.filter('phone', function (v) {
  return v ? `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7, 11)}` : ''
})
Vue.filter('cep', function (v) {
  return v ? `${v.slice(0, 2)}.${v.slice(2, 5)}-${v.slice(5, 8)}` : ''
})
Vue.filter('date', function (v) {

  if (v && v.length == 10)
    return v ? v.split('-').reverse().join('/') : ''

  if (v && v.length > 10)
    return v ? new Date(v).toLocaleString().slice(0, 17) : ''
})
Vue.filter('datetime', function (v) {
  if (v && v.length)
    return new Date(v).toLocaleDateString('pt-BR') + ' ' + new Date(v).toLocaleTimeString('pt-BR').slice(0, 5)
  return v
})
Vue.filter('money', function (v) {
  if (v == '0000') return '0,00'
  return v ? v.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '0,00'
})

Vue.filter('cpf', function (cpf) {
  if (cpf != null)
    return cpf.replace(/\D/g, "").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2")
  return
})

Vue.filter('cnpj', function (cnpj) {
  if (cnpj != null)
    return cnpj ? cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') : '';
})

//require("../tests/test.js");

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// #######################   Google Tag Manager   #######################

// DEV
/* if (env === 'dev') {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-5CB7L6N');
} */

// PROD
if (env === 'prod') {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-TF8ZX5R');
}

// TESTE / HML
if (env === 'teste') {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-TFXVML2');
}


